import "./Loader.css";

const Loader = () => {
  return <div className="loader h-[100%] aspect-square"></div>;
};

export default Loader;
